import { render, staticRenderFns } from "./PublishDemand.vue?vue&type=template&id=5ab40e34&scoped=true"
import script from "./PublishDemand.vue?vue&type=script&lang=js"
export * from "./PublishDemand.vue?vue&type=script&lang=js"
import style0 from "./PublishDemand.vue?vue&type=style&index=0&id=5ab40e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab40e34",
  null
  
)

export default component.exports